<template>
    <div
        class="animated fadeInUp"
        :class="`delay${ delay }`">
        <div
            role="button"
            tabindex="0"
            class="panelCard panelCard--hover padding-all-10 margin-bottom-20 overflow-hidden pos-relative cursor-pointer"
            @click="$emit('show-release-modal', releaseItem)"
            @keyup.enter="$emit('show-release-modal', releaseItem)">
            <span
                class="hrPrimaryLeft--3"
                :class="`content--${ filterByContentType ? releaseItem.contentType : releaseItem.contentCategory }`"></span>
            <span>{{ localizedDate(releaseItem.releaseDate.date) }}</span>
            <h4 class="h5 hl-panelBoxSmall">
                {{ releaseItem.title }}
            </h4>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            releaseItem: {
                type: Object,
                required: true,
            },
            delay: {
                type: Number,
                default: 0,
            },
            filterByContentType: {
                type: Boolean,
                required: true,
            },
        },
        methods: {
            localizedDate(timestamp) {
                return new Date(timestamp).toLocaleDateString();
            },
        },
    };
</script>
